import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { InfoIcon, MessageOptions, MessageType } from '@dreryk/react-components';

type SummaryInformationMessageOptions = MessageOptions<Record<MessageType.INFORMATIVE, string>>;

export const useSummaryInformationMessageOptions = (): SummaryInformationMessageOptions => {
   const theme = useTheme();

   return useMemo(
      () => ({
         [MessageType.INFORMATIVE]: {
            color: theme.background,
            backgroundColor: theme.backgroundLighter,
            icon: <InfoIcon />,
            labelColor: theme.backgroundDarker,
         },
      }),
      [theme]
   );
};
